import React from 'react';
import { Link } from 'react-router-dom';
import { ReactComponent as Logo } from 'assets/logos/bluecargo.svg';
import { ReactComponent as LogoBlue } from 'assets/logos/bluecargo-blue.svg';

import { Routes } from 'constants/pages';

const PUBLIC_SITE = 'https://bluecargo.io';

interface Props {
  variant?: 'larger-blue' | 'default-white';
  destination?: 'home' | 'public-site';
  className?: string;
}

const BlueCargoLogo: React.FC<Props> = (props) => {
  const { variant, destination, className } = props;

  let logo = null;
  switch (variant) {
    case 'larger-blue':
      logo = <LogoBlue className={className} />;
      break;
    case 'default-white':
    default:
      logo = <Logo className={className} />;
      break;
  }

  switch (destination) {
    case 'public-site':
      return (
        <a href={PUBLIC_SITE} className="inline-block">
          {logo}
        </a>
      );
    case 'home':
    default:
      return (
        <Link to={Routes.Home} className="inline-block">
          {logo}
        </Link>
      );
  }
};

export default BlueCargoLogo;
